import { createNamespacedHelpers } from 'vuex'

import { copyObject } from './objects'

const { mapGetters: mapAuthGetters } = createNamespacedHelpers('auth')
const { mapGetters: mapToolsGetters, mapState: mapToolsState } = createNamespacedHelpers('tools')

const mixin = {
  data: () => ({
    calendarInputProps: {
      'prepend-icon': 'event',
      height: 30,
      clearable: true,
    },
  }),
  computed: {
    ...mapAuthGetters([
      'userEmail',
    ]),
    ...mapToolsGetters([
      'currentGroups',
      'currentMetricGroups',
      'currentPageName',
      'currentReportMetrics',
      'reportOptionsForSelectedTeam',
      'currentAction',
      'selectedSearch',
    ]),
    ...mapToolsState({
      displayFilter: (state) => state.displayFilter,
      filterData: (state) => state.filterData,
      items: (state) => state.items,
      associationId: (state) => state.associationId,
      baseReportName: (state) => state.baseReportName,
      reportPath: (state) => state.reportPath,
      selectedSummary: (state) => state.selectedSummary,
      subId: (state) => state.subId,
    }),
    action() {
      return this.currentAction
    },
    isReadingReport() {
      const { action, reportPath } = this
      return reportPath && action === 'read'
    },
    haveSelectedSearch() {
      return this.selectedSearch !== null
    },
    query() {
      return this.$route.query
    },
    metrics() {
      return this.currentReportMetrics || []
    },
    favorites() {
      const { userEmail } = this
      return this.reportOptionsForSelectedTeam.filter((option) => {
        const foundRole = option.roles && option.roles.find((role) => role.userId === userEmail)
        const { isFavorite } = option
        return (!foundRole && isFavorite) || (foundRole && foundRole.isFavorite)
      }).map((report) => copyObject(report))
    },
    currentDataTableGroups() {
      const { currentGroups, currentMetricGroups } = this
      return currentMetricGroups || currentGroups
    },
  },
}

export default mixin
